module.exports = __webpack_public_path__ + "media/images/lesson_9/pais-d79fac389673c3fedbef260cf0d6df9b.png";